import React from 'react'
import '../styling/navbar.css';

export default function Navbar() {
  return (
    <div className='navbar'>
        <div className="logo">GuessYourBond</div>
        <div className="myquiz">Fun with wise</div>
    </div>
  )
}
